<template>
  <zm-radio-group
    class="opc-card-radio billing-cycle-radios"
    :aria-label="$t('billing.select_calling_plan')"
    :value="callingPlanType"
    :before-change="beforeChange"
    @input="handleUpdateCallingPlanType"
    @change="handleCallingPlanTypeChange"
  >
    <zm-radio v-for="(planAmountMap, type) in callingPlansGroupByCallingType" :key="type" :label="type">
      <p class="opc-pbx__cycle-title first-capitalize">
        {{ $t(`billing.pbx.sub_types.${type}`) }}
      </p>
      <template v-if="showPrice">
        <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(getCurrentPlan(planAmountMap))">
          <span class="opc-product-price-container__price" aria-hidden="true">
            {{ getFormattedPriceOfMonth({amount: getCurrentPlan(planAmountMap).amount, billing_cycle: BILLING_CYCLE_MONTHLY}, { forceDiff: true }) }}
          </span>
        </p>
        <p class="opc-zmone__radio-price-unit opc-price-bill-text">
          <span v-html="getMergedBilledText(BILLING_CYCLE_ANNUAL, getCurrentPlan(planAmountMap, BILLING_CYCLE_ANNUAL).amount)"></span>
          <priceVATTip />
        </p>
      </template>
    </zm-radio>
  </zm-radio-group>
</template>

<script>
import priceVATTip from '@/components/price-vat-tip.vue';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import { BILLING_CYCLE } from '@/common/constants';

export default {
  name: 'PBXCallingPlanType',
  mixins: [discountedMonthPrice],
  components: {
    priceVATTip,
  },
  model: {
    prop: 'callingPlanType',
    event: 'input',
  },
  props: {
    callingPlansGroupByCallingType: {
      type: Object,
      required: true,
    },
    callingPlanType: {
      type: String,
      required: true,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    beforeChange: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      BILLING_CYCLE_ANNUAL: BILLING_CYCLE.ANNUAL,
      BILLING_CYCLE_MONTHLY: BILLING_CYCLE.MONTHLY,
    };
  },
  methods: {
    handleUpdateCallingPlanType(value) {
      this.$emit('input', value);
    },
    handleCallingPlanTypeChange(value) {
      this.$emit('change', value);
    },
    getCurrentPlan(cycleMap, billingCycle = this.BILLING_CYCLE_MONTHLY) {
      return cycleMap[billingCycle] || {};
    }
  },
};
</script>

<style scoped></style>
